import { api } from './http';

const fetchDocumentTypes = () => api.get('/documentTypes');

export default fetchDocumentTypes;
